// あなたがチェックした商品（閲覧履歴）：snippets/recently-viewed-products.liquid
class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'ayame-recently-viewed';
    this.maxItems = 4;
  }

  connectedCallback() {
    const currentHandle = this.dataset.productHandle;
    const handles = this.getHandles();
    this.handlesToShow = handles.filter((handle) => handle !== currentHandle).slice(0, this.maxItems);

    // 表示中の商品を先頭に追加（次のページで表示する maxItems 件＋表示中の1件を残す）
    this.saveHandles([currentHandle, ...handles.filter((handle) => handle !== currentHandle)].slice(0, this.maxItems + 1));

    if (this.handlesToShow.length === 0) return;

    // おすすめ商品と同じく、画面に近づいてから読み込む
    new IntersectionObserver((entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.render();
    }, { rootMargin: '0px 0px 200px 0px' }).observe(this.parentElement);
  }

  getHandles() {
    try {
      const handles = JSON.parse(localStorage.getItem(this.storageKey));
      return Array.isArray(handles) ? handles : [];
    } catch (e) {
      return [];
    }
  }

  saveHandles(handles) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(handles));
    } catch (e) {
      // プライベートブラウズ等で保存できない場合は履歴なしとして扱う
    }
  }

  render() {
    // 表示処理が重複して呼ばれてもカードが増えないよう、1回だけ実行する
    if (this.isRendered) return;
    this.isRendered = true;

    const rootUrl = this.dataset.rootUrl.replace(/\/$/, '');
    const requests = this.handlesToShow.map((handle) =>
      fetch(`${rootUrl}/products/${encodeURIComponent(handle)}?section_id=recently-viewed-item`)
        .then((response) => (response.ok ? response.text() : ''))
        .catch(() => '')
    );

    Promise.all(requests).then((responses) => {
      const list = this.querySelector('.product-list');
      list.innerHTML = '';
      responses.forEach((responseText) => {
        // 削除・非公開になった商品（404）は表示しない
        const item = new DOMParser().parseFromString(responseText, 'text/html').querySelector('.product-list__item');
        if (item && list.children.length < this.maxItems) list.appendChild(item);
      });
      if (list.children.length > 0) this.hidden = false;
    });
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
